import { ICONS_INSIGHTS } from "@/const/insights-constants"
import { InsightsCell } from "@/molecules/InsightsCell"

import type { TFunction } from "@/hooks/useTranslation"
import type { InsightsValues } from "."

// Defaults to the agent insights; a column can pass its own list
export const AgentInsightsCell = (
  t: TFunction,
  items = [
    ICONS_INSIGHTS.runtime,
    ICONS_INSIGHTS.hasGuardrails,
    ICONS_INSIGHTS.isRoot
  ]
) => {
  return function AgentInsightsCellComponent({
    tag,
    id,
    ...values
  }: Partial<InsightsValues>) {
    return (
      <InsightsCell
        hide
        id={id}
        items={items}
        values={values}
        t={t}
        tag={tag}
      />
    )
  }
}
